import NotificationBarContainer from './NotificationBarContainer';
export default NotificationBarContainer;
